import React from "react";
import { motion } from "framer-motion";
import AboutHeading from "../Components/AboutHeading";
import Trustedby from "../Components/Trustedby";
import AboutContent from "../Components/AboutContent";
import FAQ from "../Components/FAQ";
import SEO from "../Components/SEO";

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const aboutPageSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "name": "About ElectroPlating Lebanon",
  "description": "Learn about ElectroPlating Lebanon's 25+ years of excellence in metal finishing. Family-owned business providing quality electroplating services since 1998.",
  "url": "https://www.electroplating-lb.com/about",
  "mainEntity": {
    "@type": "LocalBusiness",
    "name": "ElectroPlating Lebanon",
    "foundingDate": "1998-04",
    "description": "Family-owned electroplating business with over 25 years of experience in metal finishing."
  }
};

const AboutPage = () => {
  return (
    <main>
      <SEO
        title="About Us"
        description="Learn about ElectroPlating Lebanon's 25+ years of excellence in metal finishing. Family-owned business providing quality chrome, gold, silver, and nickel plating services since 1998."
        keywords="about electroplating Lebanon, metal finishing company, electroplating history, family business Lebanon"
        canonicalUrl="/about"
        structuredData={aboutPageSchema}
      />

      <AboutHeading />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInUp}
      >
        <AboutContent />
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
      >
        <Trustedby />
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInUp}
      >
        <FAQ />
      </motion.div>
    </main>
  );
};

export default AboutPage;
